import { FileIcon } from "assets/icons";
import Button from "components/foundation/Button";
import Modal from "components/foundation/Modal/Modal";
import TagEditForm, {
  TagFormData,
} from "components/foundation/Tag/TagEditForm";
import Toast from "components/foundation/Toast";
import { ROUTER_PATH } from "config/path";
import useCompaniesMutation from "features/tag/hooks/mutations/useCompaniesMutation";
import useCompaniesAutoCompleteQuery from "features/tag/hooks/queries/useCompaniesAutoCompleteQuery";
import useCompaniesQuery from "features/tag/hooks/queries/useCompaniesQuery";
import TagPageBoard from "pages/tag/TagPageBoard";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Link } from "react-router-dom";
import styled from "styled-components";

interface TagCreateWebPageProps {
  disableUnloadTracking: () => void;
}

const TagCreateWebPage = ({ disableUnloadTracking }: TagCreateWebPageProps) => {
  const method = useFormContext<TagFormData>();
  const { data: companiesData } = useCompaniesQuery();
  const { data: autoCompleteData } = useCompaniesAutoCompleteQuery({
    searchTerm: method.watch("tag"),
  });
  const { mutate } = useCompaniesMutation();
  const companies = companiesData.data.result;

  const [isDuplicateTag, setIsDuplicateTag] = useState(false);
  const [isSuccessToast, setIsSuccessToast] = useState(false);
  const [tags, setTags] = useState<string[]>(companies.map((i) => i.name));

  const handleSave = () => {
    // 삭제된 태그를 찾기
    const deletedTags = companies.filter((i) => !tags.includes(i.name));

    // 추가된 태그를 찾기
    const companyNamesSet = new Set(companies.map((i) => i.name));
    const addedTags = tags.filter((tag) => !companyNamesSet.has(tag));

    mutate(
      {
        addCompanies: addedTags.map((i) => ({ name: i })),
        deleteCompanyUuids: deletedTags.map((i) => i.uuid),
      },
      {
        onSuccess: () => {
          setIsSuccessToast(true);
          disableUnloadTracking();
        },
      },
    );
  };

  return (
    <>
      <Toast.Message open={isSuccessToast} onOpenChange={setIsSuccessToast}>
        변경 내용이 저장되었습니다.
      </Toast.Message>

      <Modal.Root open={isDuplicateTag} onOpenChange={setIsDuplicateTag}>
        <Modal.Body
          title="이미 존재하는 법인명입니다."
          onConfirm={() => setIsDuplicateTag(false)}
        />
      </Modal.Root>

      <TagCreatePageLayout>
        <h1>법인명 등록 / 삭제</h1>
        <TagEditForm
          tags={tags}
          setTags={setTags}
          placeholder="법인명을 추가하세요"
          onDuplicate={() => {
            setIsDuplicateTag(true);
          }}
          autocomplete={autoCompleteData?.data.result.map((i) => ({
            label: i,
            value: i,
          }))}
        />
        <div className="create-page__footer">
          <Link to={ROUTER_PATH.tag.dashboard._path}>
            <Button variant="tertiary" rightIcon={<FileIcon />} size="large">
              목록
            </Button>
          </Link>
          <Modal.Root>
            <Modal.Trigger asChild>
              <Button variant="primary" size="large">
                저장
              </Button>
            </Modal.Trigger>
            <Modal.Body
              title="변경 내용을 저장하시겠습니까?"
              onCancel
              onConfirm={handleSave}
            />
          </Modal.Root>
        </div>
      </TagCreatePageLayout>
    </>
  );
};

export default TagCreateWebPage;

const TagCreatePageLayout = styled(TagPageBoard)`
  .create-page__footer {
    display: flex;
    justify-content: space-between;
  }
`;
